import ConnectScreen from '.';

const routes = [
  {
    path: '/connect/:id',
    component: ConnectScreen,
  },
];

export default routes;
